export const INITIAL_TUTORIAL_STATE = {
  isEnabled: true,
  completedSteps: [],
  skippedSteps: [],
  currentStep: 1,
  isDismissed: false,
};

export const normalizeTutorialState = (savedState) => ({
  isEnabled: savedState?.isEnabled ?? true,
  completedSteps: Array.isArray(savedState?.completedSteps)
    ? savedState.completedSteps.filter((stepId) => Number.isInteger(stepId) && stepId >= 1 && stepId <= 8)
    : [],
  skippedSteps: Array.isArray(savedState?.skippedSteps)
    ? savedState.skippedSteps.filter((stepId) => Number.isInteger(stepId) && stepId >= 1 && stepId <= 8)
    : [],
  currentStep: typeof savedState?.currentStep === 'number' ? savedState.currentStep : 1,
  isDismissed: Boolean(savedState?.isDismissed),
});
